import Name from "@/components/Name"
import { useLocalStore } from "@/context/StateContext"
import Types from "@/types"
import { cn } from "@/utilities/cn"
import { A } from "@solidjs/router"
import { createEffect, createSignal, Index } from "solid-js"
import { v4 as uuidv4 } from "uuid"

export default function TablesView() {
  const localStore = useLocalStore()
  const [documents, setDocuments] = createSignal<any[] | null>(null)
  createEffect(async () => {
    if (!localStore.database) return
    const res = await localStore.database.find({
      selector: {
        type: Types.Category,
        target: Types.Table
      }
    })
    setDocuments(res.docs)
  })
  return (
    <div class="flex flex-col p-4 gap-4 overflow-y-auto">
      <h1>Tables</h1>
      {/* create table link */}
      <A class={"flex flex-row gap-2 p-4 border border-gray-200 rounded"} href={`/tables/${uuidv4()}`}>
        <p>Create Table</p>
      </A>
      <Index each={documents()} fallback={<p>No tables found</p>}>
        {(document) => (
          <A class={"flex flex-row gap-2 p-4 border border-gray-200 rounded"} href={`/tables/${document().origin}`}>
            <Name id={document().origin} />
          </A>
        )}
      </Index>
    </div>
  )
}
